var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"area","height":"69px","options":_vm.SalesratioChart.salesChart.chartOptions,"series":_vm.SalesratioChart.salesChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }